import { render, staticRenderFns } from "./xxList.vue?vue&type=template&id=c571a8d4&scoped=true"
import script from "./xxList.vue?vue&type=script&lang=js"
export * from "./xxList.vue?vue&type=script&lang=js"
import style0 from "./xxList.vue?vue&type=style&index=0&id=c571a8d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c571a8d4",
  null
  
)

export default component.exports